import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { KibanaNotificationDetailsModel } from '../../../models/kibana/kibana-notification-details';
import { KibanaOnboardingModel } from '../../../models/kibana/kibana-onboarding';
import { KibanaPortfolioModel } from '../../../models/kibana/kibana-portfolio';
import { KibanaPortfolioBioEdit } from '../../../models/kibana/kibana-portfolio-bioEdit';
import { KibanaPortfolioProfileModel } from '../../../models/kibana/kibana-portfolio-profile';
import { KibanaSurveyModel } from '../../../models/kibana/kibana-survey';
import { ApiLiv } from '../api-liv.service';

@Injectable({
  providedIn: 'root'
})
export class KibanaService {
  constructor(private apiLiv: ApiLiv) {}

  saveAnalyticsEvent(payload: Record<string, any>): Observable<void> {
    return this.apiLiv.post<void>('/Kibana/LIVAnalytics/SaveEvent', payload);
  }

  savePortfolioProfile(data: KibanaPortfolioProfileModel): Observable<void> {
    return this.apiLiv.post('/Kibana/Portifolio', data);
  }

  removedPortfolio(data: KibanaPortfolioModel): Observable<void> {
    return this.apiLiv.post('/Kibana/Portifolio/Remove', data);
  }

  saveNotificationListClick(): Observable<void> {
    return this.apiLiv.post('/Kibana/Notification/List', {});
  }

  saveNotificationDetailsClick(
    data: KibanaNotificationDetailsModel
  ): Observable<void> {
    return this.apiLiv.post('/Kibana/Notification/Details', data);
  }

  savePortfolioBioEdit(data: KibanaPortfolioBioEdit): Observable<void> {
    return this.apiLiv.post('/Kibana/Portifolio/BioEdit', data);
  }

  saveSurveyResponse(data: KibanaSurveyModel): Observable<void> {
    return this.apiLiv.post('/Kibana/Survey', data);
  }

  saveSurveySeeLater(slug: string): Observable<void> {
    return this.apiLiv.post(`/Kibana/Survey/SeeLater?slug=${slug}`, {});
  }

  saveOnboardingData(data: KibanaOnboardingModel): Observable<void> {
    return this.apiLiv.post('/Kibana/Onboarding', data);
  }
}
